import React from 'react';

import {Backdrop, Box, LinearProgress, Stack, Typography} from '@mui/material';

interface Props {
  startProcess: boolean;
  loadingMessage?: boolean;
  children: React.ReactNode;
}

/**
 * 子要素のみを覆うローディング表示コンポーネント
 * @param startProcess true:ローディング表示, false:ローディング非表示
 * @param param0
 * @returns
 */
export const ProgressAria = (props: Props) => {
  return (
    <Box position="relative">
      {props.children}
      {props.startProcess && (
        <Backdrop
          sx={{
            position: 'absolute',
            zIndex: 1,
            color: '#fff',
            display: 'flex',
            alignItems: 'start',
            justifyContent: 'center'
          }}
          open={true}
        >
          <Stack
            sx={{width: '100%', maxWidth: '300px', marginTop: '5%'}}
            spacing={2}
            textAlign="center"
          >
            {props.loadingMessage && (
              <>
                <Typography variant="h4" color="primary">
                  LOADING...
                </Typography>
                <LinearProgress color="primary" sx={{height: '0.75em'}} />
              </>
            )}
          </Stack>
        </Backdrop>
      )}
    </Box>
  );
};
